/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { RejectionReasonOut } from './rejectionReasonOut';

export interface RejectPreflightOut {
  allowed: boolean;
  reason_required: boolean;
  email_warning?: string | null;
  block_reason?: string | null;
  reasons?: RejectionReasonOut[];
}
